import { useCallback, useEffect, useState } from "react";
import { ResponseGetUsers } from "../user.interface";
import userService from "../user.service";

const useGetCustomerUsers = (
  customerID: string,
  query: string,
  enabeld = false
) => {
  const [data, setData] = useState<ResponseGetUsers>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return userService.getCustomerUsers(customerID, query);
  }, [query, customerID]);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [query, customerID]);

  const transformResponse = useCallback((response: ResponseGetUsers) => {
    if (response) {
      setData(response);
    }
  }, []);

  useEffect(() => {
    if (!enabeld) {
      return;
    }
    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabeld]);

  return { data, error, isLoading, refetch };
};

export default useGetCustomerUsers;
